import { ZPlayNetworkService } from "commons";

const API_BASE_URL = process.env.REACT_APP_API_EXECUTION_ADDRESS;

export default class SubscribeService {
	public static activateSubscription = (productId: string, successCallback: any, errorCallback: any) => {
		ZPlayNetworkService.put(`${API_BASE_URL}/api/subscriptions/${productId}/activate`, {}, successCallback, errorCallback);
	};

	public static getAllAvailableSubscription = (successCallback: any, errorCallback: any) => {
		ZPlayNetworkService.get(`${API_BASE_URL}/api/subscriptions/list`, successCallback, errorCallback);
	};

	public static getSubscription = (successCallback: any, errorCallback: any) => {
		ZPlayNetworkService.get(`${API_BASE_URL}/api/subscriptions/current`, successCallback, errorCallback);
	};

	public static deleteSubscription = (successCallback: any, errorCallback: any) => {
		ZPlayNetworkService.delete(`${API_BASE_URL}/api/subscriptions/current`, successCallback, errorCallback);
	};
}
